/**
 * Collection pills — Men / Women dropdowns.
 * The pill row scrolls horizontally (which would clip a dropdown), so each menu is moved
 * to <body> and positioned under its pill while open.
 */
(function () {
  const EDGE = 12;
  let openMenu = null;

  function position(menu) {
    const rect = menu.toggle.getBoundingClientRect();
    const list = menu.list;
    const left = Math.max(EDGE, Math.min(rect.left, window.innerWidth - list.offsetWidth - EDGE));
    list.style.left = left + 'px';
    list.style.top = rect.bottom + 8 + 'px';
  }

  function close(restoreFocus) {
    if (!openMenu) return;
    const menu = openMenu;
    openMenu = null;
    menu.list.hidden = true;
    menu.toggle.setAttribute('aria-expanded', 'false');
    if (restoreFocus) menu.toggle.focus({ preventScroll: true });
  }

  function open(menu) {
    close(false);
    openMenu = menu;
    menu.list.hidden = false;
    menu.toggle.setAttribute('aria-expanded', 'true');
    position(menu);
  }

  function init() {
    document.querySelectorAll('[data-vpill-menu]').forEach((wrapper) => {
      const toggle = wrapper.querySelector('.vpill--toggle');
      const list = wrapper.querySelector('.vpill-menu__list');
      if (!toggle || !list) return;
      const menu = { toggle, list };
      document.body.appendChild(list);

      toggle.addEventListener('click', () => {
        if (openMenu === menu) {
          close(false);
        } else {
          open(menu);
        }
      });

      toggle.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        if (openMenu !== menu) open(menu);
        const first = list.querySelector('a');
        if (first) first.focus();
      });

      list.addEventListener('keydown', (event) => {
        const links = Array.from(list.querySelectorAll('a'));
        const index = links.indexOf(document.activeElement);
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const next = event.key === 'ArrowDown' ? index + 1 : index - 1;
          links[(next + links.length) % links.length].focus();
        } else if (event.key === 'Tab') {
          // The list lives at the end of <body>; hand focus back to the pill row.
          const leaving = event.shiftKey ? index <= 0 : index === links.length - 1;
          if (leaving) {
            if (event.shiftKey) event.preventDefault();
            close(true);
          }
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!openMenu) return;
      if (openMenu.toggle.contains(event.target) || openMenu.list.contains(event.target)) return;
      close(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && openMenu) close(true);
    });

    // Tab from the open pill goes into its menu rather than on to the next pill.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || event.shiftKey || !openMenu || document.activeElement !== openMenu.toggle) return;
      const first = openMenu.list.querySelector('a');
      if (!first) return;
      event.preventDefault();
      first.focus();
    });

    window.addEventListener('resize', () => close(false));
    window.addEventListener(
      'scroll',
      (event) => {
        if (openMenu && !openMenu.list.contains(event.target)) close(false);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
